"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHARED_PROPS = exports.ErrorRender = void 0;
const SHARED_PROPS = exports.SHARED_PROPS = {
  'Funnel Type': 'Classic',
  'Orderpipe Version': 'New',
  'Orderpipe Test Eligible': true
};
const getError = ({
  error,
  statusText,
  status
}) => {
  if (status === 401) return 'Unauthorized';
  return error.error_code || statusText || status;
};

// When a user displays an error
const ErrorRender = ({
  error,
  statusText,
  status
}) => ['Orderpipe Error', {
  ...SHARED_PROPS,
  'Error Name': getError({
    error,
    statusText,
    status
  })
}];
exports.ErrorRender = ErrorRender;